import { render, staticRenderFns } from "./Male.vue?vue&type=template&id=ed4d6c66&scoped=true&"
import script from "./Male.vue?vue&type=script&lang=js&"
export * from "./Male.vue?vue&type=script&lang=js&"
import style0 from "./Male.vue?vue&type=style&index=0&id=ed4d6c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4d6c66",
  null
  
)

export default component.exports